import { Sprite, Texture, Rectangle } from 'pixi.js';
import { Carousel} from '@cc/pixi-app';
import { modo } from '@cc/maths-js';
import { ScreenBase } from './ScreenBase';
import { ButtonBase } from '../common/ButtonBase';
import { avatarGenerator } from '../common/AvatarGenerator';
import { Portal } from './../common/Portal';
import { dataImporter } from './../DataImporter';

/**
 */
export class ScreenPackSelect extends ScreenBase {
    /**
     */
    init() {

        this.packs = dataImporter.packs;

        this.app.sound.play("01-main-menu");

        this.background = new Sprite.from('hills_bg');
        this.background.height = this.app.resizer.height;
        this.background.anchor.set(0.5);
        this.addChild(this.background);

        this.nextArrow = new ButtonBase(new Texture.from("arrow"));
        this.nextArrow.anchor.set(0.5);
        this.nextArrow.x = 750; this.nextArrow.y = -100;
        this.nextArrow.visible = false;
        this.ui.addChild(this.nextArrow);

        this.prevArrow = new ButtonBase(new Texture.from("arrow"));
        this.prevArrow.anchor.set(0.5);
        this.prevArrow.rotation = Math.PI;
        this.prevArrow.x = -750; this.prevArrow.y = -100;
        this.prevArrow.visible = false;
        this.ui.addChild(this.prevArrow);

        this.ripples = [];
        this.particles = [];

        this.carousel = new Carousel({
            animateScale: false,
            animateAlpha: false,
            spacing: this.app.resizer.width,
            arrowNext: this.nextArrow,
            arrowPrevious: this.prevArrow,
            items: this.createCarouselItems(this.packs),
            loopItems: this.packs.length > 1,
            hitArea: new Rectangle(
                -250,
                -250,
                500,
                500
            )
        });
        this.carousel.y = -100;
        this.carousel.on('setIndex', () => this.app.sound.play("03-ui-swipe-portal"), this);
        this.carousel.setIndex(this.carousel.children.length - 1, true);
        this.animateCarousel();
        this.background.addChild(this.carousel);

        this.ui.addChild(this.createMuteButton('TopRight'));
        this.ui.addChild(this.createBackButton('TopLeft', 'avatarCreator', 'edit_avatar_btn', () => {
            this.removeParticles();
        }));

        this.avatarBack = avatarGenerator.getAnimation("avatar-back-anim", "back", false);
        this.avatar = avatarGenerator.getAnimation("avatar-front-anim", "front", false);
        this.background.addChild(this.avatar);
        this.addChild(this.avatarBack);
        this.avatarBack.position.set(0,1600);
        this.avatar.position.set(-500, 1300);
        this.avatar.setAnimation(0, "idle", true);
        this.avatarBack.setAnimation(0, "idle", true);
        this.animateAvatarIn(1000);
    }

    createCarouselItems(itemsData) {
        this.carouselItems = [];
        for (var i = 0; i < this.packs.length; i++) {
            this.carouselItems.push(new Portal(itemsData[i].packSelect, this));
        }
        return this.carouselItems;
    }

    removeParticles() {
        for (var i = 0; i < this.particles.length; i++) {
            this.particles[i].stop();
        }
    }

    animateCarousel() {
        for (var i = this.carousel.children.length - 1; i >= 0; i--) {
            let int = i;
            this.wait((this.carousel.children.length - int) * 650).call(() => this.carousel.setIndex(int));
        }
        this.wait(650 * this.carousel.children.length).call(() => {
            this.prevArrow.visible = this.packs.length > 1;
            this.nextArrow.visible = this.packs.length > 1;
            this.carousel.on('select', this.onCarouselSelect, this);
        });
    }

    animateAvatarOut(d) {
        this.tween(this.avatar)
            .wait(d)
            .to({ y: 1300 }, 900, createjs.Ease.getElasticIn(1.1, 1.5));
    }

    animateAvatarIn(d) {
        this.tween(this.avatar)
            .wait(d)
            .to({ y: 825 }, 900, createjs.Ease.getElasticOut(1.1, 1.5));
    }

    animateArrowsOut() {
        this.tween(this.prevArrow)
            .to({ x: -this.app.resizer.width }, 500, createjs.Ease.sineInOut);
        this.tween(this.nextArrow)
            .to({ x: this.app.resizer.width }, 500, createjs.Ease.sineInOut);
    }

    onCarouselSelect(index) {
        this.app.sound.play("02-ui-click");
        this.wait(900).call(() => this.animateEnteringPortal(index));
        this.animateAvatarOut(0);
        this.animateArrowsOut();
    }

    openMissionScreen(index) {
        dataImporter.currPack = this.packs[index];
        this.removeParticles();
        this.app.showScreen('missionSelect', dataImporter.currPack.tags.missionSelect);
    }

    resize() {
        this.background.height = this.app.resizer.height;
        this.background.scale.x = this.background.scale.y;
    }

    animateEnteringPortal(index) {
        this.carouselItems[index].hideIcons();
        // this.carouselItems[index].
        this.tween(this.avatarBack)
            .to({ y: 600 }, 900, createjs.Ease.getElasticIn(1.1, 1.5));
        this.wait(900).call(() => this.animateJump(index));
    }

    animateJump(index){
        this.avatarBack.setAnimation(0, "portal", false);
        this.wait(900).call(() => {
            this.app.sound.play("12-enter-portal");
            this.carouselItems[index].flash();
            this.avatarBack.visible = false;
        });
        this.wait(1350).call(()=> this.openMissionScreen(index));
    }

    /**
     */
    start() {

    }

    /**
     */
    transitionIn() { }

    update(dt) {
        super.update();
        if (this.ripples[modo(this.carousel.index, this.carouselItems.length)]){
            this.ripples[modo(this.carousel.index, this.carouselItems.length)].update(dt);
        }
    }
}
